import { formatSectionDisplayName } from "@/pages/facilities/[facilityId]/people/governance/_utils";
import type { PersonGovernanceRole } from "./types";

export {
  formatGovernanceRole,
  formatSectionDisplayName,
  getGovernanceStatusLabel,
  getGovernanceStatusTagType,
  getGovernanceStatusTagStyle,
  getEffectiveGovernanceSearch,
  clearGovernanceFilters,
  mapGovernanceStatus
} from "@/pages/facilities/[facilityId]/people/governance/_utils";

export function matchesPersonGovernanceSearch(role: PersonGovernanceRole, searchTerm: string): boolean {
  const normalizedSearch = searchTerm.trim().toLowerCase();

  if (!normalizedSearch) {
    return true;
  }

  const searchableValues = [
    role.facility.name,
    role.facility.section?.name,
    formatSectionDisplayName(role.facility.section?.name),
    role.facility.legacyId,
    role.title.title
  ];

  return searchableValues.some((value) => value?.toLowerCase().includes(normalizedSearch));
}
